export default {
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/mzlocationables.js